import React, { useState, useEffect } from 'react';
import Footer from '../component/layout/Footer';
import Header from '../component/layout/Header';
import Page from '../component/utility/Page';
import axios from 'axios';
import { mainurl } from '../Mainurl';
import { themeColors } from '../style/color';

import GraphicalReport from '../component/utility/home/GraphicalReport';
import CropGraphicalReport from '../component/utility/home/CropGraphicalReport';

import { Row, Col, Card, CardBody } from 'reactstrap';
import { GiFruitBowl, GiVillage } from 'react-icons/gi';

import { MdTrendingUp } from "react-icons/md";
import { TbPlant2 } from "react-icons/tb";
import { TbPresentationAnalyticsFilled } from "react-icons/tb";
import { FaLeaf, FaUsers } from "react-icons/fa6";
import { FaGlobeAmericas, FaMapMarkedAlt, FaHandsHelping, FaProjectDiagram } from "react-icons/fa";
import { LuSprout } from "react-icons/lu";

import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

// Enhanced TabPanel with animations
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{
        opacity: value === index ? 1 : 0,
        transform: value === index ? 'translateY(0)' : 'translateY(10px)',
        transition: 'all 0.3s ease-in-out'
      }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

// Enhanced Stat Card Component
const StatCard = ({ title, value, icon: Icon, color, trend, loading }) => (
  <Col lg={4} md={6} className="mb-2">
    <Card className="stat-card h-100 shadow-sm border-0">
      <CardBody className="p-4">
        <div className="d-flex align-items-center justify-content-between">
          <div className="flex-grow-1">
            <h6 className="stat-title text-muted mb-2 fw-medium">{title}</h6>
            <h3 className="stat-value mb-1 fw-bold" style={{ color }}>
              {loading ? (
                <div className="loading-skeleton" style={{ width: '80px', height: '32px' }} />
              ) : (
                value || '0'
              )}
            </h3>
            {trend && (
              <small className="text-success d-flex align-items-center">
                <MdTrendingUp size={14} className="me-1" />
                +{trend}% from last month
              </small>
            )}
          </div>
          <div className="stat-icon-wrapper">
            <div
              className="stat-icon d-flex align-items-center justify-content-center"
              style={{ backgroundColor: `${color}15`, color }}
            >
              <Icon size={28} />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  </Col>
);

// Loading skeleton component
const LoadingSkeleton = () => (
  <div className="loading-skeleton-wrapper">
    {[1, 2, 3, 4].map((i) => (
      <Col lg={3} md={6} className="mb-4" key={i}>
        <Card className="h-100 shadow-sm border-0">
          <CardBody className="p-4">
            <div className="loading-skeleton mb-2" style={{ width: '60%', height: '16px' }} />
            <div className="loading-skeleton mb-1" style={{ width: '40%', height: '32px' }} />
            <div className="loading-skeleton" style={{ width: '80%', height: '14px' }} />
          </CardBody>
        </Card>
      </Col>
    ))}
  </div>
);

// Empty state component
const EmptyState = ({ title, description, icon: Icon }) => (
  <div className="empty-state text-center py-5">
    <div className="empty-state-icon mb-3">
      <Icon size={64} className="text-muted opacity-50" />
    </div>
    <h5 className="text-muted mb-2">{title}</h5>
    <p className="text-muted small">{description}</p>
  </div>
);

const Home = () => {
  const [value, setValue] = useState(0);
  const [stats, setStats] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    get_db_stats();
  }, []);

  const get_db_stats = async () => {
    try {
      setLoading(true);
      const postData = [{
        "org_id": sessionStorage.getItem('org_id'),
        "user_code": sessionStorage.getItem('user_id'),
        "password": sessionStorage.getItem('user_pass')
      }];

      const response = await axios({
        method: 'post',
        url: mainurl + 'Dashboard/db_count',
        data: postData,
        headers: { 'Content-Type': 'application/json' }
      });

      const key = [
        { key_value: response.data[0].total_farmer },
        { key_value: response.data[0].total_programs },
        { key_value: response.data[0].total_cso },
        { key_value: response.data[0].total_village },
        { key_value: response.data[0].total_district },
        { key_value: response.data[0].total_state },
      ];

      setStats(key);

    } catch (error) {
      console.error('Error fetching stats:', error);
      // Handle error appropriately - you might want to show an error message
      // setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const statData = [
    {
      title: "Total Beneficiaries",
      value: stats?.[0]?.key_value,
      icon: FaUsers,
      color: themeColors.primary,
      trend: 12
    },
    {
      title: "Total Programes",
      value: stats?.[1]?.key_value,
      icon: FaProjectDiagram,
      color: themeColors.secondary,
      trend: 8
    },
    {
      title: "Total CSO",
      value: stats?.[2]?.key_value,
      icon: FaHandsHelping,
      color: themeColors.success,
      trend: 5
    },
    {
      title: "Total Village",
      value: stats?.[3]?.key_value,
      icon: GiVillage,
      color: themeColors.warning,
      trend: 15
    },
    {
      title: "Total District",
      value: stats?.[4]?.key_value,
      icon: FaMapMarkedAlt,
      color: themeColors.danger,
      trend: 15
    },
    {
      title: "Total State",
      value: stats?.[5]?.key_value,
      icon: FaGlobeAmericas,
      color: themeColors.secondary,
      trend: 15
    }
  ];

  const tabsData = [
    { label: "Kitchen Garden", icon: LuSprout },
    { label: "Vegetables", icon: GiFruitBowl },
    { label: "Horticulture", icon: FaLeaf },
    { label: "Aromatic", icon: TbPlant2 }
  ];

  return (
    <>
      <Header />

      <div className="page-container">
        <Page title='' breadcrumbs=''>
          {/* Dashboard Header */}
          <div className="dashboard-header p-3 mb-3 mt-3">
            <Row className="align-items-center">
              <Col>
                <h4 className="mb-1 fw-bold">Agricultural Dashboard</h4>
                <p className="mb-0 opacity-90">Monitor your farming operations and track key metrics</p>
              </Col>
              <Col xs="auto">
                <TbPresentationAnalyticsFilled size={48} className="opacity-75" />
              </Col>
            </Row>
          </div>

          {/* Stats Cards */}
          <Row className="g-4 mb-2">
            {loading ? (
              <LoadingSkeleton />
            ) : (
              statData.map((stat, index) => (
                <StatCard
                  key={index}
                  title={stat.title}
                  value={stat.value}
                  icon={stat.icon}
                  color={stat.color}
                  trend={stat.trend}
                  loading={loading}
                />
              ))
            )}
          </Row>

          <Card className="shadow-sm border-0 mb-3" style={{ borderRadius: '10px' }}>
            <CardBody>
              <GraphicalReport />
            </CardBody>
          </Card>


          <Card className="shadow-sm border-0 mb-3" style={{ borderRadius: '10px' }}>
            <CardBody>
              <CropGraphicalReport />
            </CardBody>
          </Card>

        </Page>
      </div>

      <Footer />
    </>
  );
};

export default Home;